<template>
  <div>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button default-href="/"></ion-back-button>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button mode="md" fill="clear" @click="saveImage">
            حفظ
          </ion-button>
        </ion-buttons>
        <ion-title>
          مراجعة
        </ion-title>
      </ion-toolbar>
    </ion-header>
<!---->
  <div class="settings">
    <h3>التاريخ</h3>
    <ion-list>
      <ion-item>
        <ion-label>تاريخ اليوم</ion-label>
        <ion-toggle slot="start" name="date" value=""
          checked @ionChange="dateToggle"
        ></ion-toggle>
      </ion-item>
    </ion-list>
  </div>
<!---->
  <div class="paper" id="paper">
    <h2 v-if="currentDate" class="title">{{ page.title }}</h2>
    <h2 v-else class="title">
      يوم ________ الموافق ___ / ___/ ٢٠٢٠م
    </h2>
    <h5 class="subtitle">{{ page.subtitle }}</h5>
    <div class="table">
      <div class="header">
        <h6>
          الفترة الصباحية
        </h6>
        <h6>
          الفترة المسائية
        </h6>
      </div>
      <div class="body">
        <div class="row">
          <table>
            <tr v-for="pos in m1_morning" :key="pos.id">
              <td>{{ pos.name }}</td>
              <td>{{ pos.user }}</td>
            </tr>
          </table>
          <table>
            <tr v-for="pos in m1_night" :key="pos.id">
              <td>{{ pos.name }}</td>
              <td>{{ pos.user }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <h5 class="subtitle">ثانياً المجندين</h5>
    <div class="table">
      <div class="header">
        <h6>8 : 2</h6>
        <h6>2 : 8</h6>
      </div>
      <div class="body">
        <div class="row">
          <table>
            <tr>
              <th style="width: 12px;">م</th>
              <th>الاسم</th>
              <th style="width: 80px;">مكان الخدمة</th>
              <th style="width: 12px;">م</th>
              <th>الاسم</th>
              <th style="width: 80px;">مكان الخدمة</th>
            </tr>
            <tr v-for="i in 20" :key="i">
              <td>{{ i }}</td>
              <td></td>
              <td></td>
              <td>{{ i }}</td>
              <td></td>
              <td></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="footer">
      <h4>مقدم/</h4>
      <h4 style="margin: 0 60px;">رئيس قسم الامن</h4>
    </div>
  </div>
  </div>
</template>

<style>
  .settings {
    height: 400vh;
  }

  .paper {
    width: 800px;
    /*height: 980px;*/
    height: 1100px;
    background: #fff;
    /*border: 2px solid #222;*/
    padding: 10px 40px;
    font-size: 12px;
    font-weight: bold;

    /* position: absolute;
    left: 50%;
    transform: translate(-50%);
    margin: 20px auto 100px; */
  }

  .title {
    font-size: 18px;
    text-align: center;
  }

  .title,
  .subtitle {
    font-weight: bold;
  }

  table {
    border-collapse: collapse;
    width: 100%;
    /* margin: 0 auto; */
  }

  td,
  th {
    border: 1px solid #999;
    padding: 0.5rem;
    text-align: right;
  }

  th[colspan="2"] {
    text-align: center;
    width: 50vw;
  }

  .header {
    display: flex;
    justify-content: center;
  }

  tr,
  td,
  th {
    line-height: 1;
    height: 24px;
    text-overflow: ellipsis;
  }

  .row table * {
    text-align: center;
  }

  h5 {
    font-size: 14px;
  }

  h6 {
    width: 100%;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
  }

  .table {
    border: 1px solid #333;
  }

  .body {
    border-top: 1px solid;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .row {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .body .row table th {
    width: 130px;
  }

  h6:not(:last-child) {
    border-left: 1px solid #333;
  }

  .footer h4 {
    font-size: 14px;
  }

  .footer {
    width: 300px;
    margin-right: auto;
    margin-top: 30px;
  }
</style>

<script>
  import db from '@/firebase.js'
  import domtoimage from 'dom-to-image-more'

  export default {
    name: 'review',
    methods: {
      saveImage() {
        let paper = document.getElementById('paper')
        domtoimage.toPng(paper)
          .then(dataURL => {
            // let img = new Image()
            // img.src = dataURL
            let l = document.createElement('a')
            let u = this.uuidv4c()
            l.download = `p${u}.png`
            l.href = dataURL
            l.click()
          })
      },
      uuidv4c() {
        return 'xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        })
      },
      dateToggle() {
        this.currentDate = !this.currentDate
      }
    },
    mounted() {
      let weekday = new Intl.DateTimeFormat("ar-eg", { weekday: "long" }).format();
      let date = new Intl.DateTimeFormat("ar-eg").format();
      this.page.title = `يوم ${weekday} الموافق ${date}`
      this.page.subtitle = 'اولاً الافراد'

      // init stuff?
      // console.log(this.users, this.m1_morning, this.m1_night)
      // this.data
    },
    created() {
      // TODO UNF*CK this mess
      db.collection('users').onSnapshot(res => {
        const changes = res.docChanges()
        changes.forEach(change => {
          if (change.type === 'added') {
            this.users.push({
              ...change.doc.data(),
              id: change.doc.id
            })
          }
          if (change.type === 'modified') {
            // https://stackoverflow.com/a/35206193
            let foundIndex = this.users.findIndex(x => x.id == change.doc.id)
            this.users[foundIndex].name = change.doc.data().name
          }
          if (change.type === 'removed') {
            this.users.pop(u => u.id == changes.doc.id)
          }
        })
      })
      db.collection('m1_morning').onSnapshot(res => {
        const changes = res.docChanges()
        changes.forEach(change => {
          if (change.type === 'added') {
            this.m1_morning.push({
              ...change.doc.data(),
              id: change.doc.id
            })
          }
          if (change.type === 'modified') {
            // https://stackoverflow.com/a/35206193
            let foundIndex = this.m1_morning.findIndex(x => x.id == change.doc.id)
            this.m1_morning[foundIndex].name = change.doc.data().name
            this.m1_morning[foundIndex].user = change.doc.data().user
          }
          if (change.type === 'removed') {
            this.m1_morning.pop(u => u.id == changes.doc.id)
          }
        })
      })
      db.collection('m1_night').onSnapshot(res => {
        const changes = res.docChanges()
        changes.forEach(change => {
          if (change.type === 'added') {
            this.m1_night.push({
              ...change.doc.data(),
              id: change.doc.id
            })
          }
          if (change.type === 'modified') {
            // https://stackoverflow.com/a/35206193
            let foundIndex = this.m1_night.findIndex(x => x.id == change.doc.id)
            this.m1_night[foundIndex].name = change.doc.data().name
            this.m1_night[foundIndex].user = change.doc.data().user
          }
          if (change.type === 'removed') {
            this.m1_night.pop(u => u.id == changes.doc.id)
          }
        })
      })
    },
    data() {
      return {
        currentDate: true,
        page: {
          title: '',
          subtitle: '',
          data: {}
        },
        users: [],
        m1_morning: [],
        m1_night: [],
        fakeData: {
          m1: {
            day: [
              { id: 1, pos: 'AA', name: 'omar' },
              { id: 2, pos: 'BB', name: 'oskr' },
            ]
          }
        }
      }
    }
  }
</script>
